export enum PlanFormMode {
    Add,
    Update
}